import { useState } from 'react'
import type { CSSProperties } from 'react'
import { videoTasks } from './projectData'
import { TaskMarkerIcon } from './TaskMarker'

const asset = (path: string) => `${import.meta.env.BASE_URL}${path}`

export default function VideoLibrary() {
  const [taskIndex, setTaskIndex] = useState(0)
  const [rawIndex, setRawIndex] = useState(0)
  const [datsIndex, setDatsIndex] = useState(0)
  const task = videoTasks[taskIndex]
  const rawVariant = task.rawVariants[rawIndex]
  const datsVariant = task.datsVariants[datsIndex]

  const selectTask = (index: number) => {
    setTaskIndex(index)
    setRawIndex(0)
    setDatsIndex(0)
  }

  return (
    <div className="video-library">
      <div className="task-selector" role="tablist" aria-label="Robot task">
        {videoTasks.map((item, index) => (
          <button
            aria-selected={index === taskIndex}
            className={index === taskIndex ? 'is-active' : ''}
            key={item.slug}
            onClick={() => selectTask(index)}
            role="tab"
            style={{ '--task-colour': item.colour } as CSSProperties}
            type="button"
          >
            <span className="task-id"><TaskMarkerIcon marker={item.marker} colour={item.colour} />{String(index + 1).padStart(2, '0')}</span>
            {item.title}
            <small>{item.rawVariants.length} raw · {item.datsVariants.length} DATS</small>
          </button>
        ))}
      </div>

      <div className="video-stage">
        <div className="video-stage-heading">
          <div>
            <p>{task.title}</p>
            <h3>{task.role}</h3>
          </div>
          <p>{task.description}</p>
        </div>
        <div className="condition-grid">
          <article className="condition-panel raw-condition">
            <div className="condition-heading">
              <p>Raw-supervision policy</p>
              <span>Collected ordering is retained</span>
            </div>
            <video key={rawVariant.video} controls playsInline preload="metadata" poster={asset(rawVariant.poster)}>
              <source src={asset(rawVariant.video)} type="video/mp4" />
            </video>
            {task.rawVariants.length > 1 && (
              <div className="variant-strip" aria-label={`${task.title} raw-policy rollouts`}>
                {task.rawVariants.map((item, index) => (
                  <button
                    aria-pressed={index === rawIndex}
                    className={index === rawIndex ? 'is-active' : ''}
                    key={item.video}
                    onClick={() => setRawIndex(index)}
                    type="button"
                  >
                    <img src={asset(item.poster)} width="640" height="360" alt="" loading="lazy" />
                    <span>{item.label}</span>
                  </button>
                ))}
              </div>
            )}
          </article>

          <article className="condition-panel dats-condition">
            <div className="condition-heading">
              <p>DATS policy</p>
              <span>Compatible streams advance together</span>
            </div>
            <video key={datsVariant.video} controls playsInline preload="metadata" poster={asset(datsVariant.poster)}>
              <source src={asset(datsVariant.video)} type="video/mp4" />
            </video>
            {task.datsVariants.length > 1 && (
              <div className="variant-strip" aria-label={`${task.title} DATS-policy rollouts`}>
                {task.datsVariants.map((item, index) => (
                  <button
                    aria-pressed={index === datsIndex}
                    className={index === datsIndex ? 'is-active' : ''}
                    key={item.video}
                    onClick={() => setDatsIndex(index)}
                    type="button"
                  >
                    <img src={asset(item.poster)} width="640" height="360" alt="" loading="lazy" />
                    <span>{item.label}</span>
                  </button>
                ))}
              </div>
            )}
          </article>
        </div>
      </div>
    </div>
  )
}
